module.exports = __webpack_public_path__ + "img/Paramitra Multifinance.5d23993f.png";